<template>
    <div class="project-container">
        <div class="row">
            <div class="left">
                <span>创建时间：</span>
                <el-date-picker v-model="startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-model="endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="right">
                <div class="select-item1">
                    <div class="label">账户类型</div>
                    <el-select v-model="searchAccountType" placeholder="请选择" clearable
                        filterable>
                        <el-option label="银行卡" value="银行卡"></el-option>
                        <el-option label="信用卡" value="信用卡"></el-option>
                        <el-option label="pingpong" value="pingpong"></el-option>
                        <el-option label="GEP" value="GEP"></el-option>
                        <el-option label="万里汇" value="万里汇"></el-option>
                        <el-option label="空中云汇" value="空中云汇"></el-option>
                        <el-option label="连连支付" value="连连支付"></el-option>
                        <el-option label="支付宝" value="支付宝"></el-option>
                        <el-option label="微信" value="微信"></el-option>
                        <el-option label="诚e付" value="诚e付"></el-option>
                    </el-select>
                </div>
                <el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select">
                    <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                        <el-option label="账户名称" value="accountName"></el-option>
                        <el-option label="账号/卡号" value="account"></el-option>
                    </el-select>
                </el-input>
                <el-button icon="el-icon-search" type="primary" @click="getData">搜 索</el-button>
                <el-button type="primary" @click="initData">重 置</el-button>
            </div>
        </div>
        <el-button type="primary" @click="createProject" class="createBtn">创 建</el-button>
        <el-button type="primary" @click="importData" class="createBtn">导 入</el-button>

        <el-table :data="tableData" border style="width: 100%" max-height="640px" :header-cell-style="getTableHeader()"
            stripe v-loading="loadData">
            <el-table-column prop="accountType" label="账户类型" width="120" align="center">
            </el-table-column>
            <el-table-column prop="accountNature" label="账户性质" width="110" align="center">
            </el-table-column>
            <el-table-column prop="accountName" label="账户名称" align="center">
            </el-table-column>
            <!-- <el-table-column prop="account" label="账号/卡号" align="center">
            </el-table-column> -->
            <!-- <el-table-column label="归集至" align="center">
                <template slot-scope="{ row }">
                    {{ row.parentAccount ? row.parentAccount.accountType + '-' + row.parentAccount.accountName + '-' +
                    row.parentAccount.account : '' }}
                </template>
            </el-table-column> -->
            <el-table-column prop="balance" label="账户余额" align="center" width="110">
            </el-table-column>
            <el-table-column prop="balanceUpdateTime" label="余额时间" align="center" width="100">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" width="100">
            </el-table-column>
            <el-table-column label="操作" align="center" width="105">
                <template slot-scope="scope">
                    <el-button type="text" @click="editRow(scope.row)">
                        导入流水
                    </el-button>
                    <!-- <el-button type="text" @click="updBalanceRow(scope.row)">
                        更新余额
                    </el-button>
                    <el-button type="text" @click="imputationRow(scope.row)">
                        归集至
                    </el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div class="page-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="创建收支账户" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div class="box">
                <div class="item w50">
                    <div class="label">账户类型<span class="required">*</span></div>
                    <el-select v-model="dialogData.accountType" slot="prepend" placeholder="请选择" allow-create
                        filterable>
                        <el-option label="银行卡" value="银行卡"></el-option>
                        <el-option label="信用卡" value="信用卡"></el-option>
                        <el-option label="pingpong" value="pingpong"></el-option>
                        <el-option label="GEP" value="GEP"></el-option>
                        <el-option label="钱海" value="钱海"></el-option>
                        <el-option label="PayPal" value="PayPal"></el-option>
                        <el-option label="万里汇" value="万里汇"></el-option>
                        <el-option label="空中云汇" value="空中云汇"></el-option>
                        <el-option label="连连支付" value="连连支付"></el-option>
                        <el-option label="支付宝" value="支付宝"></el-option>
                        <el-option label="微信" value="微信"></el-option>
                        <el-option label="诚e付" value="诚e付"></el-option>
                    </el-select>
                </div>
                <div class="item w50">
                    <div class="label">账户性质<span class="required">*</span></div>
                    <el-select v-model="dialogData.accountNature" slot="prepend" placeholder="请选择" filterable>
                        <el-option label="稳定收支" value="稳定收支"></el-option>
                        <el-option label="不稳定收支" value="不稳定收支"></el-option>
                    </el-select>
                </div>
                <div class="item w100">
                    <div class="label">账户名称</div>
                    <ElInputTrim v-model="dialogData.accountName" :disabled="!canEdit" />
                </div>
                <div class="item w100">
                    <div class="label">账号/卡号</div>
                    <ElInputTrim v-model="dialogData.account" :disabled="!canEdit" />
                </div>
            </div>
            <div slot="footer">
                <span class="dialog-footer" v-loading="isSubmit">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="submit">保 存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :title="dialogTitle" :visible.sync="updFileDialog" width="50%" :before-close="handleUpdFileClose">
            <div>
                <template v-if="dialogType === 'detail'">
                    平台：<el-select v-model="selectedPlatform" placeholder="请选择平台">
                        <el-option label="pingpong" value="pingpong"></el-option>
                        <el-option label="空中云汇" value="空中云汇"></el-option>
                        <el-option label="连连支付" value="连连支付"></el-option>
                        <el-option label="万里汇" value="万里汇"></el-option>
                        <el-option label="GEP" value="GEP"></el-option>
                        <el-option label="钱海" value="钱海"></el-option>
                        <el-option label="PayPal" value="PayPal"></el-option>
                    </el-select>
                </template>
                <el-upload class="upload-demo" ref="uploadFile" action="" :on-change="handleExcelChange"
                    :auto-upload="false" :limit="1">
                    <div slot="trigger">
                        <el-button type="primary">选取文件</el-button>
                        <!-- <el-button @click="downloadTemplate">下载模板</el-button> -->
                    </div>
                </el-upload>
                <div class="errorList" v-if="errorList.length > 0">
                    <div class="title">错误的交易id：</div>
                    <div class="errorListContent">
                        <p :key="index" v-for="(row, index) in errorList">{{row}}</p>
                    </div>
                </div>
            </div>
            <div slot="footer" v-loading="updExcelState">
                <span class="dialog-footer" v-loading="isSubmit">
                    <el-button @click="handleUpdFileClose">取 消</el-button>
                    <el-button type="primary" @click="updExcel">上 传</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog title="更新余额" :visible.sync="updBalanceDialog" width="50%" :before-close="handleUpdFileClose">
            <div>
                <el-upload class="upload-demo" ref="uploadFile" action="" :on-change="handleExcelChange"
                    :auto-upload="false" :limit="1">
                    <div slot="trigger">
                        <span>上传文件</span>
                        <el-button type="text">导入流水</el-button>
                    </div>
                </el-upload>
                <div class="row1">
                    <div class="label">更新余额时间</div>
                    <el-date-picker class="value" v-model="updBalanceDate" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="row1">
                    <div class="label">更正余额</div>
                    <ElInputTrim v-model="updBalanceVal" type="number" class="value" />
                </div>
                <div class="errorList" v-if="errorList.length > 0">
                    <div class="title">错误的交易id：</div>
                    <div class="errorListContent">
                        <p :key="index" v-for="(row, index) in errorList">{{ row }}</p>
                    </div>
                </div>
            </div>
            <div slot="footer" v-loading="updExcelState">
                <span class="dialog-footer">
                    <el-button @click="handleUpdFileClose">取 消</el-button>
                    <el-button type="primary" @click="updBalance">导入流水并更新余额</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog title="归集至" :visible.sync="imputationDialog" width="50%" :before-close="handleImputationClose">
            <div>
                <div class="">
                    选择归集账户
                    <el-select v-model="parentId" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in parentList" :key="item.id"
                            :label="item.accountType + '-' + item.accountName + '-' + item.account" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div slot="footer" v-loading="updImputationState">
                <span class="dialog-footer">
                    <el-button @click="handleImputationClose">取 消</el-button>
                    <el-button type="primary" @click="updImputation">确 定</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getTableHeader, formatDate } from '@/assets/js/common.js'
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
import { mapState } from 'vuex';
import ElInputTrim from '@/components/ElInputTrim/index.vue';
import XLSX from 'xlsx';
export default {
    name: 'IncomeExpenditureAccount',
    components: {
        ElInputTrim
    },
    props: {},
    data() {
        return {
            startDate: '',
            endDate: '',
            searchStr: '',
            searchType: 'accountName',
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            canEdit: false,
            tableData: [],
            dialogData: {
                accountType: '',
                accountNature: '',
                accountName: '',
                account: '',
            },
            searchAccountType: '',
            dialogId: null,
            loadData: false,
            isSubmit: false,
            updFileDialog: false,
            updFileObj: {},
            updFileData:[],
            errorList: [],
            updExcelState: false,
            dialogType: '',
            dialogTitle: '',
            updBalanceDialog: false,
            updBalanceDate: '',
            imputationDialog: false,
            parentList: [],
            parentId: '',
            childrenId: '',
            updImputationState: false,
            updBalanceObj: {},
            updBalanceVal: '',
            selectedPlatform: '',
            currencyCodes: [
                "GBP",  // 英镑
                "EUR",  // 欧元
                "USD",  // 美元
                "CAD",  // 加元
                "MXN",  // 墨西哥比索
                "JPY",  // 日元
                "AUD",  // 澳元
                "AED",  // 阿联酋迪拉姆
                "SGD",  // 新加坡元
                "INR",  // 印度卢比
                "SEK",  // 瑞典克朗
                "PLN",  // 波兰兹罗提
                "SAR",  // 沙特里亚尔
                "BRL",  // 巴西雷亚尔
                "HKD",   // 港元
                "CNH",  // 离岸人民币
                "CNY",  // 人民币
                "CHF", // 瑞士法郎
            ],
            currencyCodeMap: {
                "英镑": "GBP",
                "欧元": "EUR",
                "美元": "USD",
                "加拿大元": "CAD",
                "墨西哥比索": "MXN",
                "日元": "JPY",
                "澳元": "AUD",
                "阿联酋迪拉姆": "AED",
                "新加坡元": "SGD",
                "印度卢比": "INR",
                "瑞典克朗": "SEK",
                "波兰兹罗提": "PLN",
                "沙特里亚尔": "SAR",
                "巴西雷亚尔": "BRL",
                "港元": "HKD",
                "离岸人民币": "CNH",
                "人民币": "CNY",
                "瑞士法郎": "CHF",
            }
        };
    },
    watch: {},
    computed: {
        ...mapState({
            role: state => state.user.role,
        })
    },

    created() {
        // this.endDate = formatDate(Date.now(), 'YYYY-MM-DD');
        // this.startDate = this.endDate.substring(0, 7) + '-01';
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 更新归集
        async updImputation(){
            if(!this.parentId){
                this.$message.error('请选择归集账户')
                return
            }
            this.updImputationState = true;
            const params = {
                "id": this.childrenId,
                "pid": this.parentId
            }
            const api = 'incomeExpenditureAccountController/setCollectAccount';
            const resp = await ajaxPost(Baseurl + api, params);
            if (resp.status === 200 && resp.data.code === 200) {
                this.$message.success('归集成功')
            }else{
                this.$message.error(resp.data.data)
            }
            this.updImputationState = false;
            this.handleImputationClose();
            this.getData();
        },
        // 归集至 弹窗
        async imputationRow(row){
            await this.getParentData();
            this.childrenId = row.id;
            this.imputationDialog = true;
        },
        // 获取父级数据
        async getParentData(){
            this.parentList = [];
            let api = '';
            api = 'incomeExpenditureAccountController/selectParentIncomeExpenditureAccounts';
            const resp = await ajaxPost(Baseurl + api);
            if (resp.status === 200 && resp.data.code === 200){
                this.parentList = resp.data.data;
            }
        },
        // 关闭归集至弹窗
        handleImputationClose(){
            this.parentId = '';
            this.parentList = [];
            this.imputationDialog = false;
        },
        // 更新余额 弹窗
        updBalanceRow(row){
            this.dialogType = 'detail';
            this.updBalanceDialog = true;
            this.updBalanceObj = row;
        },
        async updBalance() {
            if (!this.updBalanceDate){
                this.$message.error('请选择更新余额时间');
                return;
            }
            if (!this.updBalanceVal && this.updFileData.length == 0){
                this.$message.error('请填写更正余额或上传流水明细');
                return
            }
            this.parentList = [];
            let api = '';
            const params = {
                "id": this.updBalanceObj.id,
                "balanceUpdateTime": this.updBalanceDate,
                "incomeExpenditureDetails": this.updFileData,
                "balance": this.updBalanceObj.balance || 0,
            }
            if (this.updBalanceVal){
                params.balance = this.updBalanceVal;
                params.incomeExpenditureDetails = [];
            }
            api = 'incomeExpenditureAccountController/importTransactionsUpdateBalances';
            const resp = await ajaxPost(Baseurl + api, params);
            if (resp.status === 200 && resp.data.code === 200) {
                // this.parentList = resp.data.data;
                this.$message.success('更新成功！');
                this.handleUpdFileClose();
                this.getData();
            }else{
                this.$message.error(resp.data.data || '更新失败，请稍后再试');
            }
        },
        downloadTemplate(){
            const aEle = document.createElement('a')
            if (this.dialogType === 'account'){
                aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E6%94%B6%E6%94%AF%E8%B4%A6%E6%88%B7%E6%A8%A1%E6%9D%BF.xlsx'
            } else if (this.dialogType === 'detail'){
                aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E6%94%B6%E6%94%AF%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF.xlsx'
            }
            aEle.click()
            this.$message.success('正在下载...')
        },
        importData(){
            this.dialogType = 'account';
            this.dialogTitle = '导入收支账户';
            this.updFileDialog = true;
        },
        editRow(d) {
            this.updFileObj = d;
            this.dialogType = 'detail';
            this.dialogTitle = '导入流水';
            this.selectedPlatform = d.accountType;
            this.updFileDialog = true;
        },
        // 格式化日期
        formatRowDate(rawDate) {
            if (typeof rawDate === 'number') {
                const baseDate = new Date(1899, 11, 30); // JavaScript的月份是0-11，所以11代表12月
                // 计算总毫秒数：天数 * 24小时 * 60分钟 * 60秒 * 1000毫秒
                const milliseconds = rawDate * 24 * 60 * 60 * 1000;
                // 创建新日期对象
                const date = new Date(baseDate.getTime() + milliseconds);
                return this.formatDateToString(date);
            } else if (typeof rawDate === 'string') {
                // 兼容多种格式：2025.6.17、2025/06/07 等
                const normalized = rawDate.replace(/\./g, '-').replace(/\//g, '-');
                const date = new Date(normalized);
                return isNaN(date.getTime()) ? rawDate : this.formatDateToString(date);
            } else {
                return rawDate;
            }
        },
        formatDateToString(date) {
            const pad = (n) => String(n).padStart(2, '0');
            const Y = date.getFullYear();
            const M = pad(date.getMonth() + 1);
            const D = pad(date.getDate());
            const h = pad(date.getHours());
            const m = pad(date.getMinutes());
            const s = pad(date.getSeconds());
            return `${Y}-${M}-${D} ${h}:${m}:${s}`;
        },
        // 解析pingpong流水明细excel
        parsePingPongExcel(file){
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '流水号', prop: 'transactionId', required: true, },
                    { label: '出/入账币种', prop: 'currency', required: true, },
                    { label: '交易对手方账户名', prop: 'transactionParty', },
                    { label: '交易对手方账号', prop: 'tradingAccount', },
                    { label: '出/入账金额', prop: 'amount', required: true, },
                    { label: '出账/入账', prop: 'type', required: true, },
                    { label: '创建时间', prop: 'tradingTime', required: true, },
                    { label: '业务类型', prop: 'description', },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['创建时间']) {
                        item['创建时间'] = this.formatRowDate(item['创建时间']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    if (!this.currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['amount']) {
                        obj['amount'] = +(obj['amount'] + '').replace(/[\s,]/g, "");
                    }
                    if(obj['type'] == "出账"){
                        obj['expenditure'] = obj['amount'];
                    }else if(obj['type'] == "入账"){
                        obj['income'] = obj['amount'];
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    delete obj['amount'];
                    delete obj['type'];
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                console.log(result);
                this.updFileData = result;
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        parseKongZhongExcel(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: 'Transaction Id', prop: 'transactionId', required: true, },
                    { label: 'Wallet Currency', prop: 'currency', required: true, },
                    { label: 'Amount', prop: 'amount', required: true, },
                    { label: 'Financial Transaction Type', prop: 'type', required: true, },
                    { label: 'Time', prop: 'tradingTime', required: true, },
                    { label: 'Description', prop: 'description', },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['Time']) {
                        item['Time'] = this.formatRowDate(item['Time']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    obj['transactionId'] = obj['transactionId'] + '-' + obj['type'];
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    if (!this.currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['amount']) {
                        obj['amount'] = +(obj['amount'] + '').replace(/[\s,]/g, "");
                    }
                    if (obj['type'] == "FEE" || obj['type'] == "PAYOUT") {
                        obj['expenditure'] = obj['amount'];
                    } else if (obj['type'] == "DEPOSIT") {
                        obj['income'] = obj['amount'];
                    }else{
                        continue; // 如果类型不匹配，跳过该行
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    delete obj['amount'];
                    delete obj['type'];
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                console.log(result);
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        parseWanLiHuiExcel(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '交易号', prop: 'transactionId', required: true, },
                    { label: '实际支出币种', prop: 'currency', required: true, },
                    { label: '付款人名称', prop: 'transactionParty', },
                    { label: '付款人账号', prop: 'tradingAccount', },
                    { label: '转入金额', prop: 'amount', required: true, },
                    { label: '动账类型', prop: 'type', required: true, },
                    { label: '交易创建时间', prop: 'tradingTime', required: true, },
                    { label: '描述', prop: 'description', },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['交易创建时间']) {
                        item['交易创建时间'] = this.formatRowDate(item['交易创建时间']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    obj['transactionId'] = obj['transactionId'] + '-' + obj['type'];
                    console.log(obj['currency']);
                    console.log(this.currencyCodeMap[obj['currency']]);
                    if(obj['currency']){
                        obj['currency'] = this.currencyCodeMap[obj['currency']] || obj['currency'];
                    }
                    console.log(obj['currency'])
                    if (!this.currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['amount']) {
                        obj['amount'] = +(obj['amount'] + '').replace(/[\s,]/g, "");
                    }
                    if(obj['type'] == "货币兑换"){
                        continue; // 如果类型是货币兑换，跳过该行
                    }
                    if (obj['type'] == "归集" || obj['type'] == "收款") {
                        obj['income'] = obj['amount'];
                    }else{
                        obj['expenditure'] = obj['amount'];
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    delete obj['amount'];
                    delete obj['type'];
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        parseGEPExcel(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '订单号', prop: 'transactionId', required: true, },
                    { label: '币种', prop: 'currency', required: true, },
                    { label: '交易对手方', prop: 'transactionParty', },
                    { label: '收款帐号', prop: 'tradingAccount', },
                    { label: '支出', prop: 'expenditure' },
                    { label: '收入', prop: 'income' },
                    { label: '创建时间', prop: 'tradingTime', required: true, },
                    { label: '交易类型', prop: 'description', },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                // 跳过5行，从第6行开始读取数据
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '', range: 5 });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['创建时间']) {
                        item['创建时间'] = this.formatRowDate(item['创建时间']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if(!obj['expenditure'] && !obj['income']){
                        missingTexts.push('支出或收入必须填写一个');
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    if (!this.currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['expenditure']) {
                        obj['expenditure'] = +(obj['expenditure'] + '').replace(/[\s,]/g, "");
                    }
                    if (obj['income']) {
                        obj['income'] = +(obj['income'] + '').replace(/[\s,]/g, "");
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                console.log(result);
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        parseLianLianExcel(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '交易单号', prop: 'transactionId', required: true, },
                    { label: '币种', prop: 'currency', required: true, },
                    { label: '收款人名称', prop: 'transactionParty', },
                    { label: '收款人账号', prop: 'tradingAccount', },
                    { label: '交易金额', prop: 'amount', required: true, },
                    { label: '资金方向', prop: 'type', required: true, },
                    { label: '创建日期', prop: 'tradingTime', required: true, },
                    { label: '类型', prop: 'description', },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                // 跳过5行，从第6行开始读取数据
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '', range: 4 });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['创建日期']) {
                        item['创建日期'] = this.formatRowDate(item['创建日期']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    if (!this.currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['amount']) {
                        obj['amount'] = +(obj['amount'] + '').replace(/[\s,]/g, "");
                    }
                    if(obj['type'] == "支出"){
                        obj['expenditure'] = obj['amount'];
                    }else if(obj['type'] == "收入"){
                        obj['income'] = obj['amount'];
                    }else{
                        continue; // 如果类型不匹配，跳过该行
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                console.log(result);
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        parseQianHaiExcel(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '支付ID', prop: 'transactionId', required: true, },
                    { label: '交易币种', prop: 'currency', required: true, },
                    { label: '客户姓名', prop: 'transactionParty', },
                    { label: '卡号', prop: 'tradingAccount', },
                    { label: '交易金额', prop: 'amount', required: true, },
                    // { label: '资金方向', prop: 'type', required: true, },
                    { label: '交易时间', prop: 'tradingTime', required: true, },
                    { label: '返回信息', prop: 'description', },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                const result = [];
                const errorMessages = [];
                console.log(jsonData);
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['交易时间']) {
                        item['交易时间'] = this.formatRowDate(item['交易时间']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    if (obj['currency']) {
                        obj['currency'] = this.currencyCodeMap[obj['currency']] || obj['currency'];
                    }
                    if (!this.currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['amount']) {
                        obj['amount'] = +(obj['amount'] + '').replace(/[\s,]/g, "");
                    }
                    if (obj['type'] == "货币兑换") {
                        continue; // 如果类型是货币兑换，跳过该行
                    }
                    obj['income'] = obj['amount'];
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    delete obj['amount'];
                    delete obj['type'];
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                console.log(result);
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        // 流水明细
        handleDetailDataChange(file){
            this.updFileData = [];
            switch (this.selectedPlatform) {
                case 'pingpong':
                    this.parsePingPongExcel(file);
                    break;
                case '空中云汇':
                    this.parseKongZhongExcel(file);
                    break;
                case '万里汇':
                    this.parseWanLiHuiExcel(file);
                    break;
                case 'GEP':
                    this.parseGEPExcel(file);
                    break;
                case '连连支付':
                    this.parseLianLianExcel(file);
                    break;
                case '钱海':
                    this.parseQianHaiExcel(file);
                    break;
                default:
                    this.$message.error('不支持的平台');
                    this.$refs.uploadFile.clearFiles();
                    break;
            }
        },
        // 导入的是账户
        handleAccountDataChange(file) {
            this.updFileData = [];
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '账户类型', prop: 'accountType', required: true, },
                    { label: '账户性质', prop: 'accountNature', required: true, },
                    { label: '账户名称', prop: 'accountName', required: true, },
                    { label: '账号', prop: 'account',  },
                ]

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && !item[itemHeader.label]) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                
            };
            reader.readAsArrayBuffer(file.raw);
        },
        handleExcelChange(file){
            if(this.dialogType === 'detail'){
                if(!this.selectedPlatform){
                    this.$message.error('请先选择平台');
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.handleDetailDataChange(file)
            }else if(this.dialogType === 'account'){
                this.handleAccountDataChange(file);
            }
        },
        updExcel(){
            if(this.updFileData.length === 0){
                this.$message.error('请先上传文件或等待文件解析完成');
                return
            }
            this.updExcelState = true;
            let result = [];
            let api = '';
            if(this.dialogType === 'detail'){ //流水明细
                result = this.updFileData.map(item => {
                    return {
                        ...item,
                        accountName: this.updFileObj['accountName'],
                        accountType: this.updFileObj['accountType'],
                    }
                })
                api = 'incomeExpenditureDetailsController/importIncomeExpenditureDetails';
            } else if (this.dialogType === 'account'){//账户
                result = this.updFileData;
                api = 'incomeExpenditureAccountController/batchImportIncomeExpenditureAccount';
            }
            ajaxPost(Baseurl + api, result).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        if (res.data.errorList && res.data.errorList.length > 0){
                            this.errorList = res.data.errorList;
                        }else{
                            this.handleUpdFileClose();
                            this.$message.success('上传成功！');
                            this.updFileDialog = false;
                            this.updFileData = [];
                            this.updFileObj = {};
                            if (this.dialogType === 'account'){
                                this.getData();
                            }
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                    this.updExcelState = false;
                }
                this.loadData = false;
            })
        },
        initData(){
            this.startDate = '';
            this.endDate = '';
            this.searchStr = '';
            this.searchAccountType = '';
            this.searchType = 'accountName';
            this.page = 1;
            this.size = 10;
            this.getData();
        },
        getData() {
            this.loadData = true;
            const params = {
                "page": this.page,
                "size": this.size,
            }
            if (this.startDate) {
                params['startTime'] = this.startDate + " 00:00:00"
            }
            if (this.endDate) {
                params['endTime'] = this.endDate + " 23:59:59"
            }
            if (this.searchStr) {
                params['searchType'] = this.searchType;
                params['searchStr'] = this.searchStr;
            }
            if (this.searchAccountType){
                params['accountType'] = this.searchAccountType;
            }
            ajaxPost(Baseurl + 'incomeExpenditureAccountController/selectIncomeExpenditureAccountPage', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const data = res.data;
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadData = false;
            })
        },
        // 保存一条账户
        submit() {
            const header = [
                { label: '账户类型', prop: 'accountType',},
                { label: '账户性质', prop: 'accountNature',},
                { label: '账户名称', prop: 'accountName',},
                // { label: '账号/卡号', prop: 'account',},
            ]
            const missingKeys = [];
            for(let i = 0; i < header.length; i++) {
                const item = header[i];
                if (!this.dialogData[item.prop]) {
                    missingKeys.push(item.label);
                }
            }
            if (missingKeys.length > 0) {
                this.$message.error('请填写' + missingKeys.join('、') + '！');
                return;
            }
            this.isSubmit = true;
            const params = {
                ...this.dialogData,
            }
            let text = '新建';
            let api = 'insertIncomeExpenditureAccount';
            ajaxPost(Baseurl + 'incomeExpenditureAccountController/' + api, params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.$message.success(text + '成功！');
                        this.dialogVisible = false;
                        for (let i = 0; i < header.length; i++) {
                            const item = header[i];
                            this.dialogData[item.prop] = '';
                        }
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.isSubmit = false;
            })
        },
        handleClose() {
            this.dialogVisible = false;
        },
        handleUpdFileClose(type) {
            this.$refs.uploadFile && this.$refs.uploadFile.clearFiles();
            this.errorList = [];
            this.updBalanceDialog = false;
            this.updFileDialog = false;
            this.updFileData = [];
            this.updFileObj = {};
            this.updBalanceDate = '';
            this.updBalanceVal = '';
        },
        getTableHeader,
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        createProject() {
            this.canEdit = true;
            this.dialogVisible = true
        }
    },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    /deep/ .el-date-editor {
        margin: 0 5px;
    }

    .right {
        .el-button {
            margin-left: 10px;
        }

        .el-select {
            width: 120px;
        }
        .select-item1{
            display: flex;
            align-items: center;
            
            margin-right: 10px;
            .label{
                margin-right: 5px;
                flex-shrink: 0;
            }
            .el-select{
                width: 200px;
                flex: 1;
            }

        }
    }
}

.box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;

    .item {
        width: 30%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .label {
            width: 80px;
        }

        .el-input,
        .el-textarea,
        .el-select {
            flex: 1;
        }

        &.w100 {
            width: 100%;
        }

        &.w50 {
            width: calc(50% - 10px);
        }
    }

    &.shop {
        display: block;

        .select-box {
            display: flex;

            .select-item {
                display: flex;
                align-items: center;
                margin-right: 10px;

                .select-label {
                    margin-right: 5px;
                }

                .el-select {
                    width: 250px;

                    &.w800 {
                        width: 800px;
                    }
                }
            }
        }
    }
}

/deep/ .el-tabs__content {
    max-height: 500px;
}



.editable-container {
    width: 100%;
}

.box {
    width: 100%;
    max-height: 465px;
}
.errorList{
    display: flex;
    border: 1px solid #fab6b6;
    margin-top: 10px;
    padding: 10px;
    border-radius: 5px;
}
.started {
    background-color: #70b603;
    color: #fff;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.not-started {
    background-color: #f5f5f5;
    color: #999;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.page-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.createBtn {
    margin: 10px 0;
}

.link {
    color: #409eff;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
/deep/ .el-table .cell .el-button{
    margin: 0;
}
.w300{
    width: 500px;
}
.row1{
    margin-top: 10px;
    display: flex;
    align-items: center;
    .value{
        width:250px
    }
    .label{
        margin-right: 10px;
    }
}
</style>